import React from 'react'
import { Box, LinearProgress, Typography } from '@mui/material'

interface AppLinearProgressProps {
  label?: string
}

const AppLinearProgress: React.FC<AppLinearProgressProps> = ({ label }): React.JSX.Element => {
  return (
    <Box sx={{ width: '100%', mt: 2, mb: 2 }}>
      <LinearProgress color="primary" sx={{ height: 6, borderRadius: 3 }} />
      {label && (
        <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
          {label}
        </Typography>
      )}
    </Box>
  )
}

export default AppLinearProgress
